import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PublicLayout } from '@/client/components/layout/PublicLayout';
import { RootRedirect } from '@/client/routes/RootRedirect';
import { Landing } from '@/client/routes/public/Landing';
import { NotFound } from '@/client/routes/public/NotFound';
import { Contact } from '@/client/routes/public/Contact';
import { SignUp } from '@/client/routes/public/SignUp';
import { Login } from '@/client/routes/public/Login';
import { VerifyEmail } from '@/client/routes/public/VerifyEmail';
import { ForgotPassword } from '@/client/routes/public/ForgotPassword';
import { ResetPassword } from '@/client/routes/public/ResetPassword';
import { CmsPage } from '@/client/routes/public/CmsPage';
import { AboutDajana } from '@/client/routes/public/AboutDajana';
import { AboutAcademy } from '@/client/routes/public/AboutAcademy';
import { CoursesList } from '@/client/routes/public/CoursesList';
import { CourseDetail } from '@/client/routes/public/CourseDetail';
import { Checkout } from '@/client/routes/public/Checkout';
import { ConsultationsList } from '@/client/routes/public/ConsultationsList';
import { ConsultationDetail } from '@/client/routes/public/ConsultationDetail';
import { Mentoring } from '@/client/routes/public/Mentoring';
import { BookingSubmitted } from '@/client/routes/public/BookingSubmitted';
import { BookingPayment } from '@/client/routes/public/BookingPayment';
import { PortalLayout } from '@/client/routes/portal/PortalLayout';
import { Dashboard } from '@/client/routes/portal/Dashboard';
import { Profile } from '@/client/routes/portal/Profile';
import { Sessions } from '@/client/routes/portal/Sessions';
import { PortalCourses } from '@/client/routes/portal/PortalCourses';
import { PortalCourseDetailPage } from '@/client/routes/portal/PortalCourseDetail';
import { PortalLessonPage } from '@/client/routes/portal/PortalLessonPage';
import { PortalBookings } from '@/client/routes/portal/PortalBookings';

// AdminApp pulls in ~30 admin route components (courses, bookings, emails,
// reviews, certificates, audit log, etc.). Public visitors never need any
// of that code, so we split it into its own chunk and load on first /admin
// hit. Sprint 8 Phase C performance budget: keeps the public bundle under
// the Lighthouse ≥90 ceiling on Mobile.
const AdminApp = lazy(() =>
  import('@/client/routes/admin/AdminApp').then((m) => ({ default: m.AdminApp })),
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={null}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route path="/:locale" element={<PublicLayout />}>
          <Route index element={<Landing />} />
          <Route path="o-dajane" element={<AboutDajana />} />
          <Route path="o-academy" element={<AboutAcademy />} />
          <Route path="kurzy" element={<CoursesList />} />
          <Route path="kurzy/:slug" element={<CourseDetail />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="konzultacie" element={<ConsultationsList />} />
          <Route path="konzultacie/odoslane" element={<BookingSubmitted />} />
          <Route path="konzultacie/platba" element={<BookingPayment />} />
          <Route path="konzultacie/:slug" element={<ConsultationDetail />} />
          <Route path="mentoring" element={<Mentoring />} />
          <Route path="kontakt" element={<Contact />} />
          <Route path="ochrana-sukromia" element={<CmsPage slug="ochrana-sukromia" />} />
          <Route path="gdpr" element={<CmsPage slug="gdpr" />} />
          <Route path="obchodne-podmienky" element={<CmsPage slug="obchodne-podmienky" />} />
          <Route path="cookies" element={<CmsPage slug="cookies" />} />
          <Route path="registracia" element={<SignUp />} />
          <Route path="prihlasenie" element={<Login />} />
          <Route path="overenie-emailu" element={<VerifyEmail />} />
          <Route path="zabudnute-heslo" element={<ForgotPassword />} />
          <Route path="obnova-hesla" element={<ResetPassword />} />
          <Route path="portal" element={<PortalLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="kurzy" element={<PortalCourses />} />
            <Route path="kurzy/:slug" element={<PortalCourseDetailPage />} />
            <Route path="kurzy/:slug/lekcia/:order" element={<PortalLessonPage />} />
            <Route path="rezervacie" element={<PortalBookings />} />
            <Route path="profil" element={<Profile />} />
            <Route path="profil/relacie" element={<Sessions />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
